/* =============================================================
   blank-canvas.js  (CORREGIDO)
   =============================================================
   FIX: La textura del cilindro 3D ahora respeta la zona de impresión
   real de la taza (87% de la circunferencia), con franjas blancas a
   los lados que quedan detrás del asa. Mismas constantes que
   personalizer.js (PRINT_U_START = 0.069, PRINT_U_END = 0.931).
   ============================================================= */

(function () {
  'use strict';

  // ───── Constantes ─────
  const PRINT_WIDTH = 2550;   // 8.5" * 300 DPI
  const PRINT_HEIGHT = 1050;  // 3.5" * 300 DPI
  const MAX_FILE_MB = 10;
  const ACCEPTED_TYPES = ['image/jpeg', 'image/png', 'image/webp'];

  // ───── Estado global ─────
  const state = {
    elements: [],
    selectedId: null,
    nextId: 1,
    photoCounter: 0,
    originalFiles: {},
    canvas: null,
    form: null,
    drag: null,
  };

  let DOM = {};

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    DOM.canvas = document.querySelector('.bc-canvas');
    if (!DOM.canvas) return;

    DOM.form = document.querySelector('.bc-form');
    DOM.addPhotoBtn = document.querySelector('.bc-add-photo-btn');
    DOM.addTextBtn = document.querySelector('.bc-add-text-btn');
    DOM.resetBtn = document.querySelector('.bc-reset-btn');
    DOM.fileInput = document.querySelector('.bc-shared-file-input');
    DOM.helper = document.querySelector('.bc-helper');
    DOM.textPanel = document.querySelector('.bc-text-panel');
    DOM.tbFont = document.querySelector('.bc-tb-font');
    DOM.tbSize = document.querySelector('.bc-tb-size');
    DOM.tbColor = document.querySelector('.bc-tb-color');
    DOM.tbBold = document.querySelector('.bc-tb-bold');
    DOM.tbItalic = document.querySelector('.bc-tb-italic');
    DOM.tbDelete = document.querySelector('.bc-tb-delete');
    DOM.submitBtn = document.querySelector('.bc-submit-btn');
    DOM.buyNowBtn = document.querySelector('.bc-buy-now-btn');
    DOM.processing = document.querySelector('.bc-processing');
    DOM.layoutInput = document.querySelector('.bc-layout-input');
    DOM.designFinalInput = document.querySelector('.bc-design-final-input');
    DOM.originalsContainer = document.querySelector('.bc-originals-container');
    DOM.preview3dBtn = document.querySelector('.bc-preview3d-btn');
    DOM.preview3dModal = document.querySelector('.bc-preview3d-modal');
    DOM.preview3dMount = document.querySelector('.bc-preview3d-mount');
    DOM.preview3dClose = document.querySelector('.bc-preview3d-close');

    state.canvas = DOM.canvas;

    if (DOM.addPhotoBtn) DOM.addPhotoBtn.addEventListener('click', () => DOM.fileInput.click());
    if (DOM.addTextBtn) DOM.addTextBtn.addEventListener('click', addText);
    if (DOM.resetBtn) DOM.resetBtn.addEventListener('click', resetCanvas);
    if (DOM.fileInput) DOM.fileInput.addEventListener('change', onFileSelected);

    document.addEventListener('mousedown', e => {
      if (!e.target.closest('.bc-element') && !e.target.closest('.bc-text-panel')) {
        deselectAll();
      }
    });

    if (DOM.tbFont) DOM.tbFont.addEventListener('change', () => updateSelectedText({ font: DOM.tbFont.value }));
    if (DOM.tbSize) DOM.tbSize.addEventListener('input', () => updateSelectedText({ size: parseInt(DOM.tbSize.value, 10) || 32 }));
    if (DOM.tbColor) DOM.tbColor.addEventListener('input', () => updateSelectedText({ color: DOM.tbColor.value }));
    if (DOM.tbBold) DOM.tbBold.addEventListener('click', () => {
      const el = getSelected();
      if (!el || el.type !== 'text') return;
      el.bold = !el.bold;
      DOM.tbBold.classList.toggle('active', el.bold);
      renderElement(el);
    });
    if (DOM.tbItalic) DOM.tbItalic.addEventListener('click', () => {
      const el = getSelected();
      if (!el || el.type !== 'text') return;
      el.italic = !el.italic;
      DOM.tbItalic.classList.toggle('active', el.italic);
      renderElement(el);
    });
    if (DOM.tbDelete) DOM.tbDelete.addEventListener('click', deleteSelected);

    if (DOM.submitBtn) DOM.submitBtn.addEventListener('click', e => handleSubmit(e, false));
    if (DOM.buyNowBtn) DOM.buyNowBtn.addEventListener('click', e => handleSubmit(e, true));

    if (DOM.preview3dBtn) DOM.preview3dBtn.addEventListener('click', show3DPreview);
    if (DOM.preview3dClose) DOM.preview3dClose.addEventListener('click', close3DPreview);
    if (DOM.preview3dModal) DOM.preview3dModal.addEventListener('click', e => {
      if (e.target === DOM.preview3dModal) close3DPreview();
    });

    setupQuantity();

    setHelper('Click en "+ Añadir foto" o "+ Añadir texto" para empezar tu diseño.');
  }

  function setHelper(text) {
    if (DOM.helper) DOM.helper.textContent = text;
  }

  // ═══════════════════════════════════════════════════════════
  // AÑADIR FOTO
  // ═══════════════════════════════════════════════════════════
  function onFileSelected(ev) {
    const file = ev.target.files[0];
    if (!file) return;

    if (ACCEPTED_TYPES.indexOf(file.type) === -1) {
      alert('Solo se permiten imágenes JPG, PNG o WEBP.');
      ev.target.value = '';
      return;
    }
    if (file.size > MAX_FILE_MB * 1024 * 1024) {
      alert('La foto excede ' + MAX_FILE_MB + ' MB. Sube una más pequeña.');
      ev.target.value = '';
      return;
    }

    const reader = new FileReader();
    reader.onload = e => {
      const img = new Image();
      img.onload = () => {
        const rect = DOM.canvas.getBoundingClientRect();
        const cw = rect.width || 900;
        const ch = rect.height || 370;
        const aspect = img.width / img.height;
        let w = cw * 0.4;
        let h = w / aspect;
        if (h > ch * 0.7) { h = ch * 0.7; w = h * aspect; }
        const count = state.elements.length;
        const offset = (count % 6) * 24 - 60;
        const x = (cw - w) / 2 + offset;
        const y = (ch - h) / 2 + offset;

        const id = state.nextId++;
        state.photoCounter++;
        const photoIndex = state.photoCounter;

        const element = {
          id, type: 'photo',
          x, y, w, h, rot: 0,
          src: e.target.result,
          photoIndex,
          naturalW: img.width,
          naturalH: img.height,
        };
        state.elements.push(element);
        state.originalFiles[id] = file;
        createOriginalFileInput(id, photoIndex, file);

        renderElement(element);
        selectElement(id);
        setHelper('Arrastra la foto para moverla. Tira de las esquinas para cambiar tamaño.');
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
    ev.target.value = '';
  }

  function createOriginalFileInput(elementId, photoIndex, file) {
    let input = document.querySelector('.bc-original-file-input[data-element-id="' + elementId + '"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'file';
      input.className = 'bc-original-file-input';
      input.dataset.elementId = String(elementId);
      input.style.display = 'none';
      DOM.originalsContainer.appendChild(input);
    }
    input.name = 'properties[Foto Original ' + photoIndex + ']';
    input.accept = 'image/*';
    try {
      const dt = new DataTransfer();
      dt.items.add(file);
      input.files = dt.files;
    } catch (err) {
      console.warn('[blank-canvas] DataTransfer no soportado:', err);
    }
  }

  function removeOriginalFileInput(elementId) {
    const input = document.querySelector('.bc-original-file-input[data-element-id="' + elementId + '"]');
    if (input) input.remove();
  }

  // ═══════════════════════════════════════════════════════════
  // AÑADIR TEXTO
  // ═══════════════════════════════════════════════════════════
  function addText() {
    const rect = DOM.canvas.getBoundingClientRect();
    const cw = rect.width || 900;
    const ch = rect.height || 370;
    const w = Math.min(cw * 0.4, 320);
    const h = 60;
    const count = state.elements.length;
    const offset = (count % 6) * 24 - 60;
    const x = (cw - w) / 2 + offset;
    const y = (ch - h) / 2 + offset;

    const id = state.nextId++;
    const element = {
      id, type: 'text',
      x, y, w, h, rot: 0,
      text: 'Tu texto aquí',
      font: '"Dancing Script", cursive',
      size: 36,
      color: '#1a1a1a',
      bold: false, italic: false,
    };
    state.elements.push(element);
    renderElement(element);
    selectElement(id);
    setHelper('Doble click sobre el texto para editarlo directamente.');
  }

  function updateSelectedText(changes) {
    const el = getSelected();
    if (!el || el.type !== 'text') return;
    Object.assign(el, changes);
    renderElement(el);
  }

  // ═══════════════════════════════════════════════════════════
  // RENDERIZADO DE ELEMENTOS EN EL DOM
  // ═══════════════════════════════════════════════════════════
  function renderElement(element) {
    let node = DOM.canvas.querySelector('.bc-element[data-id="' + element.id + '"]');
    if (!node) {
      node = document.createElement('div');
      node.className = 'bc-element';
      node.dataset.id = element.id;
      DOM.canvas.appendChild(node);
      attachElementHandlers(node, element);
    }
    node.style.left = element.x + 'px';
    node.style.top = element.y + 'px';
    node.style.width = element.w + 'px';
    node.style.height = element.h + 'px';
    node.style.transform = 'rotate(' + element.rot + 'deg)';
    node.style.transformOrigin = 'center center';

    if (element.type === 'photo') {
      let img = node.querySelector('img');
      if (!img) {
        img = document.createElement('img');
        node.appendChild(img);
      }
      img.src = element.src;
    } else if (element.type === 'text') {
      node.classList.add('bc-element-text');
      let textEl = node.querySelector('.bc-text-content');
      if (!textEl) {
        textEl = document.createElement('div');
        textEl.className = 'bc-text-content';
        node.appendChild(textEl);
      }
      textEl.style.fontFamily = element.font;
      textEl.style.fontSize = element.size + 'px';
      textEl.style.color = element.color;
      textEl.style.fontWeight = element.bold ? '700' : '400';
      textEl.style.fontStyle = element.italic ? 'italic' : 'normal';
      if (!textEl.classList.contains('bc-editing')) {
        textEl.textContent = element.text;
      }
    }

    if (element.id === state.selectedId) ensureHandles(node);
  }

  function ensureHandles(node) {
    if (node.querySelector('.bc-handle')) return;
    ['tl', 'tr', 'bl', 'br'].forEach(corner => {
      const h = document.createElement('div');
      h.className = 'bc-handle ' + corner;
      h.dataset.handle = corner;
      node.appendChild(h);
    });
    const rotLine = document.createElement('div');
    rotLine.className = 'bc-rotate-line';
    node.appendChild(rotLine);

    const rot = document.createElement('div');
    rot.className = 'bc-rotate-handle';
    rot.dataset.handle = 'rotate';
    rot.textContent = '↻';
    node.appendChild(rot);

    const tb = document.createElement('div');
    tb.className = 'bc-element-toolbar';
    const back = document.createElement('button');
    back.type = 'button';
    back.className = 'bc-layer-back-btn';
    back.title = 'Enviar atrás';
    back.dataset.handle = 'back';
    back.textContent = '↓';
    const fwd = document.createElement('button');
    fwd.type = 'button';
    fwd.className = 'bc-layer-forward-btn';
    fwd.title = 'Traer al frente';
    fwd.dataset.handle = 'forward';
    fwd.textContent = '↑';
    const del = document.createElement('button');
    del.type = 'button';
    del.className = 'bc-delete-btn';
    del.title = 'Eliminar';
    del.dataset.handle = 'delete';
    del.textContent = '×';
    tb.appendChild(back);
    tb.appendChild(fwd);
    tb.appendChild(del);
    node.appendChild(tb);

    updateToolbarState(node);
  }

  function clearHandles(node) {
    node.querySelectorAll('.bc-handle, .bc-rotate-handle, .bc-rotate-line, .bc-element-toolbar').forEach(h => h.remove());
  }

  function updateToolbarState(node) {
    if (!node) {
      const sel = DOM.canvas.querySelector('.bc-element.selected');
      if (!sel) return;
      node = sel;
    }
    const id = parseInt(node.dataset.id, 10);
    const idx = state.elements.findIndex(e => e.id === id);
    const back = node.querySelector('.bc-layer-back-btn');
    const fwd = node.querySelector('.bc-layer-forward-btn');
    if (back) back.disabled = idx <= 0;
    if (fwd) fwd.disabled = idx === state.elements.length - 1;
  }

  // ═══════════════════════════════════════════════════════════
  // SELECCIÓN
  // ═══════════════════════════════════════════════════════════
  function getSelected() {
    return state.elements.find(e => e.id === state.selectedId);
  }

  function selectElement(id) {
    deselectAll();
    state.selectedId = id;
    const node = DOM.canvas.querySelector('.bc-element[data-id="' + id + '"]');
    if (!node) return;
    node.classList.add('selected');
    ensureHandles(node);
    const el = getSelected();
    if (el && el.type === 'text') {
      DOM.textPanel.classList.add('active');
      DOM.tbFont.value = el.font;
      DOM.tbSize.value = el.size;
      DOM.tbColor.value = el.color;
      DOM.tbBold.classList.toggle('active', el.bold);
      DOM.tbItalic.classList.toggle('active', el.italic);
    } else {
      DOM.textPanel.classList.remove('active');
    }
    updateLayerButtons();
  }

  function deselectAll() {
    state.selectedId = null;
    DOM.canvas.querySelectorAll('.bc-element.selected').forEach(node => {
      node.classList.remove('selected');
      clearHandles(node);
    });
    if (DOM.textPanel) DOM.textPanel.classList.remove('active');
    updateLayerButtons();
  }

  function deleteSelected() {
    const el = getSelected();
    if (!el) return;
    state.elements = state.elements.filter(e => e.id !== el.id);
    const node = DOM.canvas.querySelector('.bc-element[data-id="' + el.id + '"]');
    if (node) node.remove();
    if (el.type === 'photo') removeOriginalFileInput(el.id);
    delete state.originalFiles[el.id];
    deselectAll();
  }

  function resetCanvas() {
    if (!confirm('¿Eliminar todo el diseño?')) return;
    state.elements.forEach(el => {
      if (el.type === 'photo') removeOriginalFileInput(el.id);
    });
    state.elements = [];
    state.originalFiles = {};
    state.photoCounter = 0;
    DOM.canvas.querySelectorAll('.bc-element').forEach(n => n.remove());
    deselectAll();
    setHelper('Click en "+ Añadir foto" o "+ Añadir texto" para empezar tu diseño.');
  }

  // ═══════════════════════════════════════════════════════════
  // INTERACCIÓN: drag, resize, rotate, delete, dbl-click texto
  // ═══════════════════════════════════════════════════════════
  function attachElementHandlers(node, element) {
    node.addEventListener('mousedown', onPointerDown);
    node.addEventListener('touchstart', onPointerDown, { passive: false });
    node.addEventListener('dblclick', e => {
      if (element.type !== 'text') return;
      e.stopPropagation();
      e.preventDefault();
      state.drag = null;
      document.removeEventListener('mousemove', onPointerMove);
      document.removeEventListener('mouseup', onPointerUp);
      document.removeEventListener('touchmove', onPointerMove);
      document.removeEventListener('touchend', onPointerUp);
      startInlineEdit(element, node);
    });
  }

  function startInlineEdit(element, node) {
    const textEl = node.querySelector('.bc-text-content');
    if (!textEl || textEl.classList.contains('bc-editing')) return;

    textEl.classList.add('bc-editing');
    textEl.contentEditable = 'true';
    clearHandles(node);
    textEl.focus();

    const range = document.createRange();
    range.selectNodeContents(textEl);
    const sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);

    let finished = false;
    function finish(save) {
      if (finished) return;
      finished = true;
      if (save) {
        element.text = (textEl.textContent || '').trim() || 'Texto';
      } else {
        textEl.textContent = element.text;
      }
      textEl.contentEditable = 'false';
      textEl.classList.remove('bc-editing');
      textEl.removeEventListener('blur', onBlur);
      textEl.removeEventListener('keydown', onKey);
      window.getSelection().removeAllRanges();
      renderElement(element);
      if (state.selectedId === element.id) ensureHandles(node);
      setHelper('Doble click sobre el texto para editarlo.');
    }
    function onBlur() { finish(true); }
    function onKey(e) {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        textEl.blur();
      } else if (e.key === 'Escape') {
        e.preventDefault();
        textEl.textContent = element.text;
        finish(false);
      }
    }
    textEl.addEventListener('blur', onBlur);
    textEl.addEventListener('keydown', onKey);
    setHelper('Escribe tu texto · Enter para guardar · Esc para cancelar');
  }

  function onPointerDown(ev) {
    const node = ev.currentTarget;
    if (node.querySelector('.bc-text-content.bc-editing')) return;
    ev.stopPropagation();
    const id = parseInt(node.dataset.id, 10);
    const target = ev.target;
    let handle = target.dataset && target.dataset.handle;

    if (!handle && state.selectedId === id) {
      const rect = node.getBoundingClientRect();
      const point0 = getPoint(ev);
      const lx = point0.x - rect.left;
      const ly = point0.y - rect.top;
      const TOL = 25;
      if (lx < TOL && ly < TOL) handle = 'tl';
      else if (lx > rect.width - TOL && ly < TOL) handle = 'tr';
      else if (lx < TOL && ly > rect.height - TOL) handle = 'bl';
      else if (lx > rect.width - TOL && ly > rect.height - TOL) handle = 'br';
    }

    selectElement(id);
    const el = getSelected();
    if (!el) return;

    const point = getPoint(ev);

    if (handle === 'delete') {
      ev.preventDefault();
      deleteSelected();
      return;
    }
    if (handle === 'back') {
      ev.preventDefault();
      sendBackward();
      return;
    }
    if (handle === 'forward') {
      ev.preventDefault();
      bringForward();
      return;
    }

    if (handle === 'rotate') {
      const rect = node.getBoundingClientRect();
      const cx = rect.left + rect.width / 2;
      const cy = rect.top + rect.height / 2;
      const startAngle = Math.atan2(point.y - cy, point.x - cx) * 180 / Math.PI;
      state.drag = {
        mode: 'rotate', element: el, cx, cy, startAngle, startRot: el.rot
      };
    } else if (handle && ['tl','tr','bl','br'].indexOf(handle) !== -1) {
      const canvasRect = DOM.canvas.getBoundingClientRect();
      state.drag = {
        mode: 'resize', element: el, handle,
        startW: el.w, startH: el.h, startX: el.x, startY: el.y,
        startMouseX: point.x - canvasRect.left,
        startMouseY: point.y - canvasRect.top,
        aspect: el.w / el.h,
        startSize: el.size || 36,
      };
    } else {
      const canvasRect = DOM.canvas.getBoundingClientRect();
      state.drag = {
        mode: 'move', element: el,
        startX: el.x, startY: el.y,
        startMouseX: point.x - canvasRect.left,
        startMouseY: point.y - canvasRect.top,
      };
    }

    document.addEventListener('mousemove', onPointerMove);
    document.addEventListener('mouseup', onPointerUp);
    document.addEventListener('touchmove', onPointerMove, { passive: false });
    document.addEventListener('touchend', onPointerUp);
    if (ev.cancelable) ev.preventDefault();
  }

  function onPointerMove(ev) {
    if (!state.drag) return;
    if (ev.cancelable) ev.preventDefault();
    const point = getPoint(ev);
    const drag = state.drag;
    const el = drag.element;
    const canvasRect = DOM.canvas.getBoundingClientRect();

    if (drag.mode === 'move') {
      const mouseX = point.x - canvasRect.left;
      const mouseY = point.y - canvasRect.top;
      el.x = drag.startX + (mouseX - drag.startMouseX);
      el.y = drag.startY + (mouseY - drag.startMouseY);
      renderElement(el);
    } else if (drag.mode === 'resize') {
      const mouseX = point.x - canvasRect.left;
      const mouseY = point.y - canvasRect.top;
      const dx = mouseX - drag.startMouseX;
      const dy = mouseY - drag.startMouseY;
      let newW = drag.startW;
      let newH = drag.startH;
      let newX = drag.startX;
      let newY = drag.startY;

      const useAspect = el.type === 'photo' || el.type === 'text';
      if (drag.handle === 'br') {
        newW = drag.startW + dx;
        newH = useAspect ? newW / drag.aspect : drag.startH + dy;
      } else if (drag.handle === 'tr') {
        newW = drag.startW + dx;
        newH = useAspect ? newW / drag.aspect : drag.startH - dy;
        newY = drag.startY + (drag.startH - newH);
      } else if (drag.handle === 'bl') {
        newW = drag.startW - dx;
        newH = useAspect ? newW / drag.aspect : drag.startH + dy;
        newX = drag.startX + (drag.startW - newW);
      } else if (drag.handle === 'tl') {
        newW = drag.startW - dx;
        newH = useAspect ? newW / drag.aspect : drag.startH - dy;
        newX = drag.startX + (drag.startW - newW);
        newY = drag.startY + (drag.startH - newH);
      }
      if (newW < 30) newW = 30;
      if (newH < 20) newH = 20;
      el.x = newX;
      el.y = newY;
      el.w = newW;
      el.h = newH;
      if (el.type === 'text') {
        const scale = newW / drag.startW;
        el.size = Math.max(8, Math.min(300, Math.round(drag.startSize * scale)));
        if (DOM.tbSize) DOM.tbSize.value = el.size;
      }
      renderElement(el);
    } else if (drag.mode === 'rotate') {
      const angle = Math.atan2(point.y - drag.cy, point.x - drag.cx) * 180 / Math.PI;
      el.rot = drag.startRot + (angle - drag.startAngle);
      renderElement(el);
    }
  }

  function onPointerUp() {
    state.drag = null;
    document.removeEventListener('mousemove', onPointerMove);
    document.removeEventListener('mouseup', onPointerUp);
    document.removeEventListener('touchmove', onPointerMove);
    document.removeEventListener('touchend', onPointerUp);
  }

  function getPoint(ev) {
    if (ev.touches && ev.touches.length) {
      return { x: ev.touches[0].clientX, y: ev.touches[0].clientY };
    }
    if (ev.changedTouches && ev.changedTouches.length) {
      return { x: ev.changedTouches[0].clientX, y: ev.changedTouches[0].clientY };
    }
    return { x: ev.clientX, y: ev.clientY };
  }

  // ═══════════════════════════════════════════════════════════
  // RENDER HIGH-RES
  // ═══════════════════════════════════════════════════════════
  async function renderHighRes() {
    const wasSelected = state.selectedId;
    deselectAll();

    let blob;
    try {
      if (typeof html2canvas !== 'undefined') {
        const visualW = DOM.canvas.clientWidth || 900;
        const scale = PRINT_WIDTH / visualW;
        const rendered = await html2canvas(DOM.canvas, {
          scale: scale,
          backgroundColor: '#ffffff',
          useCORS: true,
          allowTaint: true,
          logging: false,
        });
        blob = await new Promise(r => rendered.toBlob(r, 'image/png', 1.0));
      } else {
        blob = await renderHighResManual();
      }
    } catch (err) {
      console.warn('[blank-canvas] html2canvas falló, usando fallback manual:', err);
      blob = await renderHighResManual();
    }

    if (wasSelected) selectElement(wasSelected);
    return blob;
  }

  async function renderHighResManual() {
    const canvas = document.createElement('canvas');
    canvas.width = PRINT_WIDTH;
    canvas.height = PRINT_HEIGHT;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, PRINT_WIDTH, PRINT_HEIGHT);
    const scaleX = PRINT_WIDTH / DOM.canvas.clientWidth;
    const scaleY = PRINT_HEIGHT / DOM.canvas.clientHeight;
    for (const el of state.elements) {
      ctx.save();
      const cx = (el.x + el.w / 2) * scaleX;
      const cy = (el.y + el.h / 2) * scaleY;
      const w = el.w * scaleX;
      const h = el.h * scaleY;
      ctx.translate(cx, cy);
      ctx.rotate(el.rot * Math.PI / 180);
      if (el.type === 'photo') {
        const img = await loadImage(el.src);
        ctx.drawImage(img, -w / 2, -h / 2, w, h);
      } else if (el.type === 'text') {
        let fontStyle = '';
        if (el.italic) fontStyle += 'italic ';
        fontStyle += el.bold ? '700 ' : '400 ';
        ctx.font = fontStyle + (el.size * scaleY) + 'px ' + el.font;
        ctx.fillStyle = el.color;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(el.text, 0, 0);
      }
      ctx.restore();
    }
    return new Promise(resolve => canvas.toBlob(blob => resolve(blob), 'image/png', 1.0));
  }

  function loadImage(src) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = src;
    });
  }

  // ═══════════════════════════════════════════════════════════
  // VISTA 3D — CORREGIDA: respeta la zona de impresión real
  // ═══════════════════════════════════════════════════════════
  let _mug3d = null;

  async function show3DPreview() {
    if (typeof THREE === 'undefined') {
      alert('Three.js no se cargó. Recarga la página.');
      return;
    }
    if (typeof html2canvas === 'undefined') {
      alert('html2canvas no se cargó. Recarga la página.');
      return;
    }

    DOM.preview3dModal.classList.add('active');
    DOM.preview3dMount.innerHTML = '<div style="padding:40px;text-align:center;color:#888">Cargando vista 3D…</div>';

    if (_mug3d) { _mug3d.dispose(); _mug3d = null; }

    setTimeout(async () => {
      try {
        _mug3d = await createMugPreview3D(DOM.preview3dMount);
      } catch (err) {
        console.error('[blank-canvas] Error vista 3D:', err);
        DOM.preview3dMount.innerHTML = '<div style="padding:20px;color:#d93939;">Error generando vista 3D.</div>';
      }
    }, 50);
  }

  function close3DPreview() {
    DOM.preview3dModal.classList.remove('active');
    if (_mug3d) { _mug3d.dispose(); _mug3d = null; }
  }

  async function createMugPreview3D(mount) {
    const w = mount.clientWidth || 800;
    const h = 500;

    const scene = new THREE.Scene();
    scene.background = new THREE.Color(0xf3f0eb);

    const R = 3.6, DIAMETER = R * 2, MH = DIAMETER * 1.19, WALL = 0.22;
    const camera = new THREE.PerspectiveCamera(34, w/h, 0.1, 500);
    camera.position.set(0, MH * 0.55, 24);
    camera.lookAt(0, MH * 0.45, 0);

    const renderer = new THREE.WebGLRenderer({ antialias: true, powerPreference: 'high-performance' });
    renderer.setSize(w, h);
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    if (THREE.SRGBColorSpace) renderer.outputColorSpace = THREE.SRGBColorSpace;
    mount.innerHTML = '';
    mount.appendChild(renderer.domElement);

    scene.add(new THREE.AmbientLight(0xffffff, 0.60));
    const keyL = new THREE.DirectionalLight(0xffffff, 0.52);
    keyL.position.set(10, 16, 14);
    keyL.castShadow = true;
    keyL.shadow.mapSize.set(2048, 2048);
    keyL.shadow.radius = 4;
    keyL.shadow.bias = -0.002;
    scene.add(keyL);
    const fillL = new THREE.DirectionalLight(0xffffff, 0.28);
    fillL.position.set(-12, 10, 8);
    scene.add(fillL);
    const backL = new THREE.DirectionalLight(0xffffff, 0.12);
    backL.position.set(2, 5, -14);
    scene.add(backL);

    // ───────────────────────────────────────────────────────
    // Capturar el canvas con html2canvas → usar como textura
    // ───────────────────────────────────────────────────────
    deselectAll();
    const captured = await html2canvas(DOM.canvas, {
      scale: 3,
      backgroundColor: '#ffffff',
      useCORS: true,
      allowTaint: true,
      logging: false,
    });

    // Texture canvas - alta resolución
    const texCanvas = document.createElement('canvas');
    texCanvas.width = 4096;
    texCanvas.height = 1559;
    const tctx = texCanvas.getContext('2d');
    tctx.imageSmoothingEnabled = true;
    tctx.imageSmoothingQuality = 'high';

    // Fondo blanco completo (incluye las zonas detrás del asa)
    tctx.fillStyle = '#ffffff';
    tctx.fillRect(0, 0, texCanvas.width, texCanvas.height);

    // ★★★ FIX PRINCIPAL ★★★
    // El diseño NO cubre los 360° del cilindro. Hay una franja blanca a
    // izquierda y derecha que en el 3D queda detrás del asa.
    // Mismas constantes que personalizer.js → área de impresión real ≈ 86.2%
    //
    // VERTICAL: el diseño se imprime de piso a borde COMPLETO (toda la
    // altura de la taza es área sublimada), así que llenamos printH entero
    // sin franjas blancas arriba/abajo.
    // HORIZONTAL: llenamos también todo el ancho de la zona imprimible
    // (entre las franjas del asa). El captured se estira a ese rectángulo.
    const PRINT_U_START = 0.069;
    const PRINT_U_END   = 0.931;
    const printX = PRINT_U_START * texCanvas.width;
    const printY = 0;
    const printW = (PRINT_U_END - PRINT_U_START) * texCanvas.width;
    const printH = texCanvas.height;

    tctx.drawImage(captured, printX, printY, printW, printH);

    const texture = new THREE.CanvasTexture(texCanvas);
    if (THREE.SRGBColorSpace) texture.colorSpace = THREE.SRGBColorSpace;
    texture.flipY = true;
    texture.wrapS = THREE.RepeatWrapping;
    texture.wrapT = THREE.ClampToEdgeWrapping;
    texture.minFilter = THREE.LinearMipmapLinearFilter;
    texture.magFilter = THREE.LinearFilter;
    texture.generateMipmaps = true;
    texture.anisotropy = renderer.capabilities.getMaxAnisotropy();
    texture.offset.x = 0.50;
    texture.needsUpdate = true;

    // Cuerpo exterior (cilindro cerrado)
    const outerGeom = new THREE.CylinderGeometry(R, R, MH, 128, 1, false);
    const ceramicMat = new THREE.MeshStandardMaterial({
      map: texture, color: 0xffffff, roughness: 0.45, metalness: 0.0
    });
    const body = new THREE.Mesh(outerGeom, ceramicMat);
    body.position.y = MH / 2;
    body.castShadow = true;
    body.receiveShadow = true;

    const whiteMat = new THREE.MeshStandardMaterial({
      color: 0xf8f8f8, roughness: 0.2, metalness: 0.0
    });

    const topCover = new THREE.Mesh(new THREE.CircleGeometry(R + 0.005, 64), whiteMat);
    topCover.rotation.x = -Math.PI / 2;
    topCover.position.y = MH + 0.002;
    const bottomCover = new THREE.Mesh(new THREE.CircleGeometry(R + 0.005, 64), whiteMat);
    bottomCover.rotation.x = Math.PI / 2;
    bottomCover.position.y = -0.002;

    const innerGeom = new THREE.CylinderGeometry(R - WALL, R - WALL, MH * 0.96, 128, 1, true);
    const innerMat = new THREE.MeshStandardMaterial({
      color: 0xeeebe5, roughness: 0.45, metalness: 0, side: THREE.BackSide
    });
    const innerMesh = new THREE.Mesh(innerGeom, innerMat);
    innerMesh.position.y = MH / 2 + MH * 0.02;

    const insideBottom = new THREE.Mesh(
      new THREE.CircleGeometry(R - WALL, 128),
      new THREE.MeshStandardMaterial({ color: 0xe5e2dc, roughness: 0.6 })
    );
    insideBottom.rotation.x = -Math.PI / 2;
    insideBottom.position.y = MH * 0.04;

    const rimRing = new THREE.Mesh(
      new THREE.RingGeometry(R - WALL, R + 0.005, 128),
      whiteMat
    );
    rimRing.rotation.x = -Math.PI / 2;
    rimRing.position.y = MH + 0.003;

    const H_THICK = 0.45, H_REACH = 3.1;
    const H_TOP_ATTACH = MH * 0.78, H_BOT_ATTACH = MH * 0.18;
    const handleCurve = new THREE.CatmullRomCurve3([
      new THREE.Vector3(0, H_TOP_ATTACH, -R),
      new THREE.Vector3(0, H_TOP_ATTACH + 0.2, -(R + 1.2)),
      new THREE.Vector3(0, H_TOP_ATTACH - 0.5, -(R + H_REACH * 0.85)),
      new THREE.Vector3(0, MH * 0.55, -(R + H_REACH)),
      new THREE.Vector3(0, MH * 0.4, -(R + H_REACH)),
      new THREE.Vector3(0, H_BOT_ATTACH + 0.5, -(R + H_REACH * 0.85)),
      new THREE.Vector3(0, H_BOT_ATTACH - 0.2, -(R + 1.2)),
      new THREE.Vector3(0, H_BOT_ATTACH, -R)
    ]);
    const handleGeom = new THREE.TubeGeometry(handleCurve, 96, H_THICK, 20, false);
    const handle = new THREE.Mesh(handleGeom, whiteMat);
    handle.castShadow = true;

    const mugGroup = new THREE.Group();
    mugGroup.add(body, topCover, bottomCover, innerMesh, insideBottom, rimRing, handle);
    scene.add(mugGroup);

    const floor = new THREE.Mesh(
      new THREE.CircleGeometry(20, 64),
      new THREE.MeshStandardMaterial({ color: 0xeae7e0, roughness: 0.95 })
    );
    floor.rotation.x = -Math.PI / 2;
    floor.position.y = -0.01;
    floor.receiveShadow = true;
    scene.add(floor);

    let raf = null, rot = 0.5, isDrag = false, dragX = 0, rotSnap = 0, dragPointerId = null;
    function animate() {
      raf = requestAnimationFrame(animate);
      if (!isDrag) rot += 0.004;
      mugGroup.rotation.y = rot;
      renderer.render(scene, camera);
    }
    animate();

    renderer.domElement.style.touchAction = 'none';
    renderer.domElement.style.cursor = 'grab';

    function onDown(e) {
      isDrag = true; dragX = e.clientX; rotSnap = rot;
      dragPointerId = e.pointerId;
      if (dragPointerId != null && renderer.domElement.setPointerCapture) {
        try { renderer.domElement.setPointerCapture(dragPointerId); } catch (_) {}
      }
      renderer.domElement.style.cursor = 'grabbing';
      if (e.preventDefault) e.preventDefault();
    }
    function onMove(e) {
      if (!isDrag) return;
      const w = renderer.domElement.clientWidth || mount.clientWidth || 400;
      rot = rotSnap + ((e.clientX - dragX) / w) * Math.PI;
    }
    function onUp(e) {
      isDrag = false;
      if (dragPointerId != null && renderer.domElement.releasePointerCapture) {
        try { renderer.domElement.releasePointerCapture(dragPointerId); } catch (_) {}
      }
      dragPointerId = null;
      renderer.domElement.style.cursor = 'grab';
    }
    renderer.domElement.addEventListener('pointerdown', onDown);
    renderer.domElement.addEventListener('pointermove', onMove);
    renderer.domElement.addEventListener('pointerup', onUp);
    renderer.domElement.addEventListener('pointercancel', onUp);

    function onResize() {
      const nw = mount.clientWidth || 800;
      camera.aspect = nw / h;
      camera.updateProjectionMatrix();
      renderer.setSize(nw, h);
    }
    window.addEventListener('resize', onResize);
    let ro = null;
    if (typeof ResizeObserver !== 'undefined') {
      ro = new ResizeObserver(entries => {
        for (const e of entries) {
          if (e.contentRect.width > 0 && Math.abs(e.contentRect.width - renderer.domElement.width / renderer.getPixelRatio()) > 2) {
            onResize();
          }
        }
      });
      ro.observe(mount);
    }
    setTimeout(onResize, 100);

    return {
      dispose() {
        cancelAnimationFrame(raf);
        renderer.domElement.removeEventListener('pointerdown', onDown);
        renderer.domElement.removeEventListener('pointermove', onMove);
        renderer.domElement.removeEventListener('pointerup', onUp);
        renderer.domElement.removeEventListener('pointercancel', onUp);
        window.removeEventListener('resize', onResize);
        if (ro) { ro.disconnect(); ro = null; }
        if (mount.contains(renderer.domElement)) mount.removeChild(renderer.domElement);
        renderer.dispose();
        outerGeom.dispose(); innerGeom.dispose(); handleGeom.dispose();
        texture.dispose();
      }
    };
  }

  // ═══════════════════════════════════════════════════════════
  // CAPAS (z-order)
  // ═══════════════════════════════════════════════════════════
  function bringForward() {
    const el = getSelected();
    if (!el) return;
    const idx = state.elements.indexOf(el);
    if (idx < 0 || idx === state.elements.length - 1) return;
    state.elements.splice(idx, 1);
    state.elements.splice(idx + 1, 0, el);
    reorderDom();
  }

  function sendBackward() {
    const el = getSelected();
    if (!el) return;
    const idx = state.elements.indexOf(el);
    if (idx <= 0) return;
    state.elements.splice(idx, 1);
    state.elements.splice(idx - 1, 0, el);
    reorderDom();
  }

  function reorderDom() {
    state.elements.forEach(el => {
      const node = DOM.canvas.querySelector('.bc-element[data-id="' + el.id + '"]');
      if (node) DOM.canvas.appendChild(node);
    });
    updateToolbarState();
  }

  function updateLayerButtons() {
    updateToolbarState();
  }

  // ═══════════════════════════════════════════════════════════
  // SUBMIT AL CARRITO
  // ═══════════════════════════════════════════════════════════
  async function handleSubmit(ev, isBuyNow) {
    ev.preventDefault();
    if (state.elements.length === 0) {
      alert('Añade al menos una foto o un texto antes de continuar.');
      return;
    }

    if (DOM.processing) DOM.processing.classList.add('active');
    DOM.submitBtn && (DOM.submitBtn.disabled = true);
    DOM.buyNowBtn && (DOM.buyNowBtn.disabled = true);

    try {
      const designBlob = await renderHighRes();
      const designFile = new File([designBlob], 'diseno-final.png', { type: 'image/png' });

      const dt = new DataTransfer();
      dt.items.add(designFile);
      DOM.designFinalInput.files = dt.files;

      const layout = {
        canvasWidth: DOM.canvas.clientWidth,
        canvasHeight: DOM.canvas.clientHeight,
        printWidth: PRINT_WIDTH,
        printHeight: PRINT_HEIGHT,
        elements: state.elements.map(el => ({
          id: el.id,
          type: el.type,
          x: Math.round(el.x),
          y: Math.round(el.y),
          w: Math.round(el.w),
          h: Math.round(el.h),
          rot: Math.round(el.rot * 100) / 100,
          ...(el.type === 'text' ? {
            text: el.text, font: el.font, size: el.size,
            color: el.color, bold: el.bold, italic: el.italic
          } : { photoIndex: el.photoIndex }),
        })),
      };
      DOM.layoutInput.value = JSON.stringify(layout);

      if (isBuyNow) {
        let returnTo = DOM.form.querySelector('input[name="return_to"]');
        if (!returnTo) {
          returnTo = document.createElement('input');
          returnTo.type = 'hidden';
          returnTo.name = 'return_to';
          DOM.form.appendChild(returnTo);
        }
        returnTo.value = '/checkout';
      }

      DOM.form.submit();
    } catch (err) {
      console.error('[blank-canvas] Error generando diseño:', err);
      alert('Hubo un error generando el diseño. Intenta de nuevo.');
      if (DOM.processing) DOM.processing.classList.remove('active');
      DOM.submitBtn && (DOM.submitBtn.disabled = false);
      DOM.buyNowBtn && (DOM.buyNowBtn.disabled = false);
    }
  }

  // ═══════════════════════════════════════════════════════════
  // CANTIDAD
  // ═══════════════════════════════════════════════════════════
  function setupQuantity() {
    const qtyVal = document.querySelector('.bc-qty-value');
    const qtyMinus = document.querySelector('.bc-qty-minus');
    const qtyPlus = document.querySelector('.bc-qty-plus');
    const qtyInput = document.querySelector('.bc-qty-input');
    if (!qtyVal) return;

    function setQty(v) {
      if (v < 1) v = 1;
      if (v > 99) v = 99;
      qtyVal.textContent = v;
      if (qtyInput) qtyInput.value = v;
      const unit = parseInt(DOM.submitBtn?.dataset.unitPrice || '0', 10);
      if (!isNaN(unit) && unit > 0) {
        document.querySelectorAll('.bc-cart-price').forEach(span => {
          span.textContent = '$' + ((unit * v) / 100).toFixed(2);
        });
      }
    }
    if (qtyMinus) qtyMinus.addEventListener('click', () => setQty(parseInt(qtyVal.textContent, 10) - 1));
    if (qtyPlus) qtyPlus.addEventListener('click', () => setQty(parseInt(qtyVal.textContent, 10) + 1));
    setQty(parseInt(qtyVal.textContent, 10) || 1);
  }
})();